// Gen-X Photo Studio JA - Real Data
export const storeLocations = [
  {
    id: 1,
    name: "Morant Bay",
    address: "Main Street, Morant Bay, St. Thomas",
    phone: "1 (876) 805-1013",
    hours: "Mon-Sat: 9AM-6PM",
    isMain: true
  },
  {
    id: 2,
    name: "107 King Street",
    address: "107 King Street, Kingston",
    phone: "1 (876) 805-1013",
    hours: "Mon-Sat: 9AM-6PM",
    isMain: false
  },
  {
    id: 3,
    name: "31 King Street",
    address: "31 King Street, Kingston",
    phone: "1 (876) 805-1013",
    hours: "Mon-Sat: 9AM-6PM",
    isMain: false
  },
  {
    id: 4,
    name: "Half Way Tree",
    address: "Half Way Tree, Kingston",
    phone: "1 (876) 805-1013",
    hours: "Mon-Sat: 9AM-6PM",
    isMain: false
  }
];

export const statistics = {
  locations: 4,
  products: "200+",
  customers: "5,000+"
};

export const heroImages = {
  main: "https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg",
  valentine: "https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg"
};

export const customCategories = [
  {
    id: 1,
    name: "Photo Frames",
    image: "https://images.pexels.com/photos/1266808/pexels-photo-1266808.jpeg",
    count: 24
  },
  {
    id: 2,
    name: "Canvas Prints",
    image: "https://images.pexels.com/photos/1579708/pexels-photo-1579708.jpeg",
    count: 18
  },
  {
    id: 3,
    name: "Photo Books",
    image: "https://images.pexels.com/photos/3014856/pexels-photo-3014856.jpeg",
    count: 12
  },
  {
    id: 4,
    name: "Mugs & Gifts",
    image: "https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg",
    count: 30
  }
];

export const valentineGifts = [
  {
    id: 1,
    name: "Couple Portrait Session",
    price: 299,
    originalPrice: 499,
    image: "https://images.pexels.com/photos/3014856/pexels-photo-3014856.jpeg",
    badge: "40% OFF"
  },
  {
    id: 2,
    name: "Heart Photo Frame",
    price: 45,
    originalPrice: 65,
    image: "https://images.pexels.com/photos/1266808/pexels-photo-1266808.jpeg",
    badge: "Best Seller"
  },
  {
    id: 3,
    name: "Love Story Book",
    price: 89,
    originalPrice: 120,
    image: "https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg",
    badge: "New"
  }
];

export const dailySpecials = [
  {
    id: 1,
    title: "Passport Photos",
    description: "Professional passport photos ready in 10 minutes",
    price: 1500,
    originalPrice: 2000,
    image: "https://images.pexels.com/photos/3785079/pexels-photo-3785079.jpeg",
    badge: "Popular"
  },
  {
    id: 2,
    title: "Canvas Print 16x20",
    description: "High-quality canvas prints for your memories",
    price: 4500,
    originalPrice: 6000,
    image: "https://images.pexels.com/photos/1579708/pexels-photo-1579708.jpeg",
    badge: "25% OFF"
  },
  {
    id: 3,
    title: "Photo Restoration",
    description: "Bring old photos back to life",
    price: 3000,
    originalPrice: 4000,
    image: "https://images.pexels.com/photos/3014856/pexels-photo-3014856.jpeg",
    badge: "New Service"
  }
];
